import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';

import intl from '$intl';
import { screen } from '../../../components/hoc';
import FactoryHeader from '$fcomponents/header';
import { TableView2, Header as FixedHeader } from '$gcomponents/widgets';

import FILE_TABLE, { FILE_TABLE_CONFIG } from './table';
import PasscodeDialog from './passcodeDialog';
import { IonPageWrapper } from './styles';
import { fileActions } from '$fbusiness/redux/file';
import { fetchFolders } from '$fbusiness/redux/file/folderActions';
import { flattenFolders } from '$fbusiness/models/fileFolder';
import StoreModel from '$fbusiness/models/store';
import FileModel from '$fbusiness/models/file';
import { configs } from '$configs';

interface MyFilesScreenProps {
  store: StoreModel;
}

const Header =
  configs.display.layout === 'FIXED_HEADER' ? (
    <FactoryHeader title="SCREEN.FILES.TITLE" />
  ) : (
    <FixedHeader title="SCREEN.FILES.TITLE" />
  );

const MyFilesScreen: React.FC<MyFilesScreenProps> = ({ store }) => {
  const [filter, setFilter] = useState<any>({ query: '', forceRefresh: true, storeId: store?.id });
  const [passcodeFile, setPasscodeFile] = useState<FileModel | null>(null);
  const [folderOptions, setFolderOptions] = useState<Array<any>>([]);

  // The factory owns its own folder tree, so the list is fetched rather than
  // imported from a shared constant.
  useEffect(() => {
    (async () => {
      const tree = await fetchFolders();
      setFolderOptions(
        flattenFolders(tree).map(({ folder, depth }) => ({
          value: folder.id,
          labelText: `${'\u00a0\u00a0'.repeat(depth)}${depth ? '└ ' : ''}${folder.name}`,
        })),
      );
    })();
  }, []);

  // Selecting a folder shows everything inside it, subfolders included.
  const onChangeFolder = (folderId) => {
    setFilter({ ...filter, folderId: folderId || undefined, forceRefresh: !filter.forceRefresh });
  };

  return (
    <IonPageWrapper>
      {Header}
      <div className="type-filter">
        <FormControl size="small" variant="outlined">
          <InputLabel id="type-select">{intl('SCREEN.FILES.COLS.FOLDER')}</InputLabel>
          <Select
            size="small"
            id="type-select"
            variant="outlined"
            label={intl('SCREEN.FILES.COLS.FOLDER')}
            value={filter.folderId || ''}
            onChange={(e) => onChangeFolder(e.target.value)}>
            <MenuItem value="">{intl('SCREEN.FILES.ALL_TYPES')}</MenuItem>
            {folderOptions.map((o) => (
              <MenuItem key={o.value} value={o.value}>
                {o.labelText}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
      <TableView2
        tableConfig={FILE_TABLE_CONFIG}
        TABLE={FILE_TABLE((file) => setPasscodeFile(file))}
        filter={filter}
      />
      <PasscodeDialog file={passcodeFile} show={!!passcodeFile} onClose={() => setPasscodeFile(null)} />
    </IonPageWrapper>
  );
};

const mapStateToProps = (state) => ({
  store: state.factory.store,
  resetOnRoute: true,
});

const mapDispatchToProps = {
  fetchFile: fileActions.fetchFile,
};

const connected = connect(mapStateToProps, mapDispatchToProps);

export default connected(screen(MyFilesScreen));
